<template>
  <!-- 新-代理管理首页 -->
  <div class="firm-body">
    <div class="title-Individual-center Contract">
      企业中心<i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">代理服务</span>
      <!-- <div class="View-Sign firm-clickable" @click="handelViewSignOpen">
        签订电子合同/查看电子合同
      </div> -->
    </div>
    <!-- 主体部分 -->
    <div class="firm-Content-subject">
      <div class="switchable">
        <div class="content">
          <div
            class="content-box firm-clickable"
            v-for="(item, index) in listArr"
            :key="index"
            @click="handelClick(item)"
          >
            <div class="content-top"></div>
            <div class="content-bottom">
              <div class="title">{{ item.serviceName }}</div>

              <div class="agreement" v-if="item.serviceAgreement">
                <div class="checkbox-box firm-clickable" @click.stop="">
                  <el-checkbox v-model="item.checked"></el-checkbox>
                </div>
                <div class="agreement-p firm-clickable">
                  已阅读并同意侦迹云<span
                    @click.stop="handelAgreement"
                    style="color: #409eff "
                    >《{{ item.Agreement }}》</span
                  >允许侦迹云统一管理本人账号记账信息
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="content-box"></div> -->
        </div>
      </div>
    </div>
    <ProtocolPopup
      :dialogAgr="dialogAgr"
      :agreement="''"
      @handleClose="dialogAgr = false"
    ></ProtocolPopup>
    <ImgDetails
      :dialogIMGDetails="dialogIMGDetails"
      :IMGdata="IMGdata"
      :ViewSign="ViewSign"
      @handleCancel="dialogIMGDetails = false"
      @handelViewSign="handelViewSign"
    ></ImgDetails>
  </div>
</template>

<script>
import ImgDetails from "../../firmTalent/talentFile/components/ImgDetails.vue";
import ProtocolPopup from "../../../signin/components/ProtocolPopup.vue";
import * as API from "@/assets/api/Agency/Enterprise.js";
import { companyPageMenu } from "../../../../assets/api/Agency/Enterprise";
export default {
  data() {
    return {
      listArr: [
        {
          id: 1,
          serviceName: "企业服务",
          serviceAgreement: true, //是否有服务协议
          checked: true,
          url: "/Choice",
          Agreement: "代理记账协议", // 协议
          val: 0,
          type: 11,
        },
        {
          id: 2,
          serviceName: "同行代理",
          serviceAgreement: true, //是否有服务协议
          checked: true,
          url: "/Choice",
          Agreement: "同行代理协议", // 协议
          val: 1,
          type: 22,
        },
        {
          id: 3,
          serviceName: "发票管理",
          serviceAgreement: false, //是否有服务协议
          checked: true,
          url: "/ProxyService/Invoice",
          Agreement: "客户管理协议", // 协议
        },
      ], //企业服务
      dialogAgr: false, //协议弹窗
      dialogIMGDetails: false, //合同
      IMGdata: [], // 合同数据
      ViewSign: 0, //区分签订合同下载合同查看合同
    };
  },
  watch: {},
  components: { ProtocolPopup, ImgDetails },
  created() {
    API.queryCompanyPaySetting().then((res) => {
      if (res.code == 0) {
        localStorage.setItem("PaymentPwd", res.data);
      }
    });
  },
  destroyed() {},
  methods: {
    // 点击签订电子合同/查看
    handelViewSignOpen() {
      this.dialogIMGDetails = true;
    },
    // 签订/下载
    handelViewSign() {},
    //协议弹窗
    handelAgreement() {
      this.dialogAgr = true;
    },
    // 点击每个模块跳转
    handelClick(item) {
      console.log(item , 'item')
      var data = {
        data: {
          proxyModel: 0,
          creditCode: this.$store.getters.getCompany.creditCode, //当前企业信用代码
          menuCode: item.type, //父级
        },
      };
      if (item.id == 1 || item.id == 2) {
        // 请求接口 获取页面功能
        companyPageMenu(data).then((res) => {
          if (res.code == 0) {
            //判断返回data不为空
            if (
              res.data != [] &&
              res.data != "" &&
              res.data != null &&
              res.data != undefined
            ) {
              //页面功能有开启
              if (item.serviceAgreement == true && item.checked == true) {
                this.$router.push({ path: item.url, query: { key: item.id } });
              } else if (item.serviceAgreement == false) {
                this.$router.push({ path: item.url, query: { key: item.id } });
              } else {
                this.$tool.PromptBox(
                  "warning",
                  "请先阅读并勾选《代理记账协议》"
                );
              }
            }else{
              // 页面没有代理服务功能开启
              this.$tool.PromptBox("error", `该地区暂未开启${item.serviceName}`);
            }
          }
        });
      } else {
        // 其他的先看是否勾选用户协议在进行对应显示
        if (item.serviceAgreement == true && item.checked == true) {
          this.$router.push({ path: item.url, query: { key: item.id } });
        } else if (item.serviceAgreement == false) {
          this.$router.push({ path: item.url, query: { key: item.id } });
        } else {
          this.$tool.PromptBox("warning", "请先阅读并勾选《代理记账协议》");
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.Contract {
  display: flex;
  .el-icon-arrow-right {
    margin: auto 5px;
  }
  .View-Sign {
    height: 20px;
    line-height: 20px;
    background-color: #409eff ;
    margin-left: 20px;
    border-radius: 5px;
    padding: 0 5px;
    color: #eeeeee;
    font-size: 12px;
    cursor: pointer;
  }
}
// 选择框的大小
/deep/.el-checkbox__inner {
  width: 13px;
  height: 13px;
  margin-right: 5px;
  border: 1px solid #409eff ;
  border-radius: 50px;
}
.firm-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .firm-Content-subject {
    width: 100%;
    min-height: 620px;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    .switchable {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .content {
      width: 95%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-bottom: 10px;
      margin: 0 auto;
      .content-box {
        width: 48%;
        background: #ffffff;
        box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        margin-bottom: 20px;
        .content-top {
          width: 100%;
          height: 150px;
          background: #eeeeee;
          border-radius: 10px 10px 0px 0px;
        }
        .content-bottom {
          height: 70px;
          padding: 20px 20px 20px 20px;
          .title {
            height: 18px;
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #333333;
            font-weight: 600;
            margin-bottom: 30px;
            // border: 1px solid gold;
          }
          .agreement {
            width: 100%;
            height: 30px;
            display: flex;
            .agreement-p {
              font-family: PingFangSC-Medium;
              font-size: 10px;
              color: #666666;
              font-weight: 400;
              margin-top: 2px;
              line-height: 38px;
            }
          }
        }
      }
    }
  }
}
</style>
